import { Link } from "react-router-dom";
import { formatDateShort } from "../../utils/dateAndTime";

export const RecentFightsList = ({ fights }) => {
  if (!fights || fights.length === 0) return null;

  return (
    <div>
      <h2 className="font-heading text-lg font-bold uppercase tracking-wider text-white mb-3">Recent Fights</h2>
      <div className="space-y-2">
        {fights.map((fight) => {
          const formattedDate = fight.date ? formatDateShort(fight.date) : "";

          const homeTeam = fight.GameDetails?.HomeTeamDetails;
          const awayTeam = fight.GameDetails?.AwayTeamDetails;

          return (
            <Link
              key={fight.FightID}
              to={`/fight/${fight.FightID}`}
              className="flex items-center justify-between bg-flyers-charcoal/50 border border-flyers-dark-gray rounded px-4 py-3 hover:border-flyers-orange/50 transition-colors duration-150"
            >
              <div className="flex items-center gap-4">
                <span className="text-flyers-mid-gray text-sm w-16">{formattedDate}</span>
                <span className="text-white">
                  {fight.Player1Details?.firstName} {fight.Player1Details?.lastName}
                  <span className="text-flyers-orange mx-2 font-heading font-bold">vs</span>
                  {fight.Player2Details?.firstName} {fight.Player2Details?.lastName}
                </span>
              </div>
              <div className="hidden sm:flex items-center gap-3 text-flyers-mid-gray text-sm">
                {homeTeam && awayTeam && (
                  <span>
                    {homeTeam.city} vs {awayTeam.city}
                  </span>
                )}
                <span className="text-flyers-orange">{fight.stats?.totalVotes || 0} votes</span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
